import { contract } from './contract';

export const obj = contract<any>('object');
